import React from 'react';

import DataTable from '../shared/data_table';
import StatusPill from '../shared/status_pill';

/*
 * bank response lines (the preview and the held queue): what the bank said, which payment it
 * matched, and what applying does or did.
 */
const columns = (on_open_teacher, action) => {
  const cols = [
    { key: 'line_no', label: 'Line' },
    {
      key: 'bank',
      label: 'Bank says',
      render: (r) => (
        <div>
          <div>
            <span className="tp-mono">{r.status_code}</span> {r.beneficiary_name}
          </div>
          <div className="tp-hint">
            {r.account_last4 ? `A/c …${r.account_last4} · ` : ''}
            {r.ifsc}
            {r.value_date ? ` · ${r.value_date}` : ''}
          </div>
          {r.bank_reference ? <div className="tp-hint tp-mono">UTR {r.bank_reference}</div> : null}
          {r.bank_reason ? <div className="tp-hint">{r.bank_reason}</div> : null}
        </div>
      )
    },
    { key: 'amount', label: 'Amount', align: 'right' },
    {
      key: 'match',
      label: 'Matched',
      render: (r) => (
        <div>
          <StatusPill tone={r.match.tone}>{r.match.label}</StatusPill>
          {r.teacher_uuid && on_open_teacher ? (
            <div>
              <button
                type="button"
                className="tp-link"
                aria-label={`Open ${r.teacher_name || 'the teacher'}'s ${r.pay_month} payouts`}
                onClick={() => on_open_teacher(r.teacher_uuid, r.pay_month)}
              >
                {r.teacher_name || 'Teacher'} · {r.pay_month}
              </button>
            </div>
          ) : null}
          {r.item_state ? <div className="tp-hint">Payment: {r.item_state.label}</div> : null}
        </div>
      )
    },
    {
      key: 'outcome',
      label: 'Outcome',
      render: (r) => (
        <div>
          <StatusPill tone={r.proposed.tone}>{r.proposed.label}</StatusPill>
          <div className="tp-hint">{r.applied.label}</div>
          {r.ops_action ? (
            <div className="tp-hint">
              Ops: {r.ops_action}
              {r.action_note ? ` (${r.action_note})` : ''}
            </div>
          ) : null}
        </div>
      )
    }
  ];
  return action
    ? cols.concat([{ key: 'action', label: 'Action', hideInCard: true, render: action }])
    : cols;
};

const LinesTable = ({ rows, on_open_teacher, action, empty_text = 'No lines.' }) => (
  <DataTable
    columns={columns(on_open_teacher, action)}
    rows={rows}
    rowKey={(r) => String(r.line_id)}
    emptyText={empty_text}
    cardTitle={(r) => <b>{`Line ${r.line_no} · ${r.amount}`}</b>}
  />
);

export default LinesTable;
